import Category from '@common/models/Category';
import PageHeader from '@common/models/PageHeader';
import { RootState } from '@common/store';
import MobileCategoryDropdown from '@components/Layouts/MobileCategoryDropdown';
import HideOnScroll from '@lib/HideOnScroll';
import React from 'react';
import { connect } from 'react-redux';

import CategoryDropdown from './CategoryDropdown';

export interface FilterBarProps {
  categories: Category[];
  className: string;
  filterBarTopPosition?: number;
  pageHeader: PageHeader;
  setTitle?: (val) => void;
}

const FilterBar: React.FunctionComponent<FilterBarProps> = ({
  categories,
  pageHeader,
  className = '',
  filterBarTopPosition,
  setTitle,
}) => {
  const filterBarLinks = pageHeader?.navbarLinks || [];
  const updatedFilterLinks = filterBarLinks?.filter((link) => link.storeLink !== '/') || [];
  let filterBar = [];
  if (updatedFilterLinks.length > 4) {
    const childObject = updatedFilterLinks.splice(4 - updatedFilterLinks.length - 1) || [];
    filterBar = [
      {
        id: 1111,
        name: 'More',
        label: 'More',
        storeLink: '#',
        childCategories: [...childObject],
      },
    ];
  }
  const navlinkDropdownItems = [
    { id: '-1', name: 'Home', storeLink: '/' },
    categories[0],
    ...updatedFilterLinks,
    ...filterBar,
  ];

  return (
    <HideOnScroll top={filterBarTopPosition} className="-mt-10 md:mt-0 h-48 md:h-60 inline" mobile={true} web={true}>
      <div
        className={`bg-navbar-navBg md:bg-navbar-navBgSecondary md:shadow-filterbar ${className}`}
        color-customisation="header-bg"
      >
        <div className="md:flex justify-between items-center mt-2 md:mt-0 navbar-hide-scroll">
          <div
            className="container mx-auto hidden md:flex flex-no-wrap overflow-x-auto overflow-y-hidden hideScroll"
            id={'menu-container'}
          >
            {navlinkDropdownItems?.map((category, index) => (
              <CategoryDropdown
                className="md:pr-40 pr-18 py-18 first:pl-0"
                key={category?.id}
                category={category}
                isFirstElement={index === 0}
              />
            ))}
          </div>
          <div className="md:hidden">
            {navlinkDropdownItems.map((category) => (
              <MobileCategoryDropdown className="" key={category?.id} category={category} setTitle={setTitle} />
            ))}
          </div>
        </div>
      </div>
    </HideOnScroll>
  );
};

export default connect(({ global, filterBar }: RootState) => ({
  filterBarTopPosition: global.filterBarTopPosition,
  filterBar,
}))(FilterBar);
